//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

// 资金计划业务部
const businesDepartment = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalPlan/businesDepartment/businesDepartment.vue')),
    'businesDepartment'
  );
// 资金计划业务部-维护
const safeguardDepartment = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalPlan/businesDepartment/safeguardDepartment.vue')),
    'safeguardDepartment'
  );
// 资金计划-表外融资
const financing = (r) =>
  require.ensure([], () => r(require('@/pages/capitalPlan/financing/financing.vue')), 'financing');
// 资金计划维护-表外融资
const safeguardFinancing = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalPlan/financing/safeguardFinancing.vue')),
    'safeguardFinancing'
  );
// 资金计划-贸易融资和内部往来
const tradeFinance = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalPlan/tradeFinance/tradeFinance.vue')),
    'tradeFinance'
  );
// 资金计划维护-表外融资
const safeguardTradeFinancing = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalPlan/tradeFinance/safeguardTradeFinancing.vue')),
    'safeguardTradeFinancing'
  );
// 资金预报表-外币
const foreignCurrency = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalPlan/fundFrecast/foreignCurrency.vue')),
    'foreignCurrency'
  );
// 资金预报表-人民币
const foundFrecastRMB = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalPlan/fundFrecast/foundFrecastRMB.vue')),
    'foundFrecastRMB'
  );
const capitalPlanRouter = {
  path: '/capitalPlan',
  component: index,
  children: [
    {
      path: 'businesDepartment',
      name: 'businesDepartment',
      component: businesDepartment,
      meta: {
        keepAlive: true,
        title: '资金计划业务部',
      },
    },
    {
      path: 'safeguardDepartment',
      name: 'safeguardDepartment',
      component: safeguardDepartment,
      meta: {
        keepAlive: true,
        title: '资金计划维护-业务部',
      },
    },
    {
      path: 'financing',
      name: 'financing',
      component: financing,
      meta: {
        keepAlive: true,
        title: '资金计划-表外融资',
      },
    },
    {
      path: 'safeguardFinancing',
      name: 'safeguardFinancing',
      component: safeguardFinancing,
      meta: {
        keepAlive: true,
        title: '资金计划维护-表外融资',
      },
    },
    {
      path: 'tradeFinance',
      name: 'tradeFinance',
      component: tradeFinance,
      meta: {
        keepAlive: true,
        title: '资金计划-贸易融资和内部往来',
      },
    },
    {
      path: 'safeguardTradeFinancing',
      name: 'safeguardTradeFinancing',
      component: safeguardTradeFinancing,
      meta: {
        keepAlive: true,
        title: '资金计划维护-贸易融资和内部往来',
      },
    },
    {
      path: 'foreignCurrency',
      name: 'foreignCurrency',
      component: foreignCurrency,
      meta: {
        keepAlive: true,
        title: '资金预报表-外币',
      },
    },
    {
      path: 'foundFrecastRMB',
      name: 'foundFrecastRMB',
      component: foundFrecastRMB,
      meta: {
        keepAlive: true,
        title: '资金预报表-人民币',
      },
    },
  ],
};
export default capitalPlanRouter;
